/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */

'use strict';

const baggageObserverMixin = require('../modules/mixins/baggages_observer.mixin');
const pricePublisherMixin = require('../modules/mixins/price_publisher.mixin');
const priceSubscriberMixin = require('../modules/mixins/price_subscriber.mixin');
const trackingPageFlowMixin = require('../modules/mixins/tracking.page.flow.mixin');

Odigeo.defineWidget('pricemanager_enhanced', Odigeo.Widget.extend(
    priceSubscriberMixin.extend(pricePublisherMixin.extend(baggageObserverMixin.extend(
        trackingPageFlowMixin.extend({
            modelClass: require('../modules/models/pricemanager_enhanced.model'),

            viewClass: require('../modules/views/pricemanager_enhanced.view'),

            init: function() {
                this.suscribeBaggagesCollectionEvents();
            },

            onBaggageLoaded: function() {
                this.onBaggageChange();
            },

            onBaggageChange: function() {
                Odigeo._.each(this.getBaggagePriceBreakDownItems(), function(bagsInSegment) {
                    var bagItem = this.getPriceBreakdownItemByConceptKey(bagsInSegment.idRow);

                    if (!Odigeo._.isUndefined(bagItem)) {
                        bagItem.set('departureIata', bagsInSegment.departureIata)
                            .set('arrivalIata', bagsInSegment.arrivalIata)
                            .set('baggageApplicationLevel', bagsInSegment.baggageApplicationLevel);
                    }
                }, this);

                this.renderView();
            },

            renderView(data = null) {
                if (!data) {
                    data = this.getPriceCollectionData();
                }
                this.view.renderView(data);
            },

            showCcSelected: function() {
                this.view.showCcNameSelected.apply(this.view, arguments);
            },

            updateFlag: function() {
                this.view.updateFlag.apply(this.view, arguments);
            },

            showPaymentMethodDisclaimer: function() {
                this.view.showPaymentMethodDisclaimer.apply(this.view, arguments);
            },

            showPayWithGuarantee: function() {
                this.view.showPayWithGuarantee();
            },

            hidePayWithGuarantee: function() {
                this.view.hidePayWithGuarantee();
            },

            hideTotalPriceContainer(toggle) {
                this.view.hideTotalPriceContainer(toggle);
            },

            checkIfOfferPricesTextSizeShouldBeResized: function() {
                this.view.checkIfOfferPricesTextSizeShouldBeResized();
            },

            setPayWithGuaranteeTrackingConditionsData(data) {
                this.model.setPayWithGuaranteeTrackingConditionsData(data);
                this.view.setPayWithGuaranteeTrackingConditionsData();
            },

            setRepricing: function() {
                var args = [].slice.call(arguments, 0);
                var repricing = Odigeo._.extend({}, args[0]);
                repricing.formattedPrices = {
                    oldPrice: Odigeo.Utils.splitFormatedCurrency(repricing.oldPrice),
                };
                this.model.set('repricing', repricing);
                this.view.renderTotalPriceSection(this.model);
            },

            refreshOfferPricesTextSize: function() {
                this.view.refreshOfferPricesTextSize();
            },

            showAutoApplyDiscountLabel(isAutoApplyDiscount) {
                this.view.showAutoApplyDiscountLabel(isAutoApplyDiscount);
            },

            getMembershipPerks() {
                return this.getPriceCollectionData().membershipPerks;
            },
        }))))));
